import { FETCH_DASHBOARD_STATUS, FETCH_DASHBOARD_STATUS_IS_ERROR, FETCH_DASHBOARD_STATUS_IS_PENDING } from 'services/Dashboard/types';

const dasboardReducer = (
  state = {
    fetchStatusIsCompleted: false,
    fetchStatusIsPending: false,
    fetchStatusIsError: null,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_DASHBOARD_STATUS:
      return {
        ...state,
        fetchStatusIsCompleted: true,
        fetchStatusIsPending: false,
        fetchStatusIsError: null,
      };
    case FETCH_DASHBOARD_STATUS_IS_PENDING:
      return {
        ...state,
        fetchStatusIsCompleted: false,
        fetchStatusIsPending: true,
        fetchStatusIsError: null,
      };
    case FETCH_DASHBOARD_STATUS_IS_ERROR:
      return {
        ...state,
        fetchStatusIsCompleted: true,
        fetchStatusIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchStatusIsError: action.error,
      };

    default:
      return state;
  }
};

export default dasboardReducer;
